import { ControlSelectionMode } from '../../../types/types';
import { isEmptyValue } from '../../../utils/managerUtils';

export const displayConfirmationModal = (
  control: any,
  rowsToUse: any[]
): boolean => {
  const selectionMode: ControlSelectionMode =
    control.selectionMode ?? 'dontcare';

  const useConfirmMsg0 =
    !isEmptyValue(control?.confirmMsg0) && rowsToUse.length === 0;
  const useConfirmMsg1 =
    !isEmptyValue(control?.confirmMsg1) && rowsToUse.length === 1;
  const useConfirmMsgX =
    !isEmptyValue(control?.confirmMsgX) && rowsToUse.length > 1;
  const useConfirmMsgXMore =
    !isEmptyValue(control?.confirmMsgXMore) && rowsToUse.length > 5;

  const showModalByNumberOfRows =
    useConfirmMsg0 || useConfirmMsg1 || useConfirmMsgX || useConfirmMsgXMore;

  // When "dontcare" or "dontcare_useall" always use confirmMsg0
  if (
    (selectionMode === 'dontcare' || selectionMode === 'dontcare_useall') &&
    !isEmptyValue(control?.confirmMsg0)
  ) {
    return true;
  }

  // When "any" use message by avaliability of messages and rows in selectedRows property
  if (selectionMode === 'any') {
    return showModalByNumberOfRows;
  }

  // Whe "justonen" use confirmMsg1 if avaliable. Apply also for expandedRow.
  if (selectionMode === 'justone' && useConfirmMsg1) {
    return true;
  }

  // Will be transferred all selected records as list if selected more than one items
  if (
    selectionMode === 'oneormore' &&
    (useConfirmMsgX || useConfirmMsgXMore || useConfirmMsg1)
  ) {
    return true;
  }

  return false;
};
